import { render, staticRenderFns } from "./EvaluationsStatistics.vue?vue&type=template&id=ec67df7a&scoped=true"
import script from "./EvaluationsStatistics.vue?vue&type=script&lang=js"
export * from "./EvaluationsStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec67df7a",
  null
  
)

export default component.exports